module.exports = __webpack_public_path__ + "img/features-support-01.0dd81574.jpg";